import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList
} from 'recharts'
import { menopauseScoreConfig } from '../comp/HSDContainer'
import './MenopauseBarChart.css'

const formatSymptomName = (symptomKey) => {
  if (!symptomKey) return ''
  return symptomKey
    .replace(/_menopause$/, '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, function(char) {
      return char.toUpperCase()
    })
}

const menopauseLevelColorMap = {
  Severe: '#D5001C',
  Moderate: '#FFB800',
  Mild: '#A8C66C',
  Minimal: '#50C878'
}

const CustomTooltip = (props) => {
  const payload = Array.isArray(props.payload) ? props.payload : []
  const fullData = props.fullData || {}

  if (payload.length === 0 || !payload[0] || !payload[0].payload) {
    return null
  }

  const category = payload[0].payload.category
  const categoryScore = payload[0].value

  if (!category || !fullData[category]) {
    return (
      <div className="custom-tooltip">No data available for this category.</div>
    )
  }

  const config = menopauseScoreConfig(categoryScore)
  const symptoms = fullData[category]

  return (
    <div className="custom-tooltip-container">
      <div className="tooltip-category-header">
        <span>{category}</span>
        <span style={{ color: (config && config.color) || '#666' }}>
          {(config && config.text) || 'Unknown'}
        </span>
      </div>
      <hr className="tooltip-divider" />

      {Object.entries(symptoms).map(function([symptomKey, details]) {
        const level = (details && details.level) || 'Unknown'
        const color = menopauseLevelColorMap[level] || '#666'
        return (
          <div key={symptomKey} className="tooltip-symptom-row">
            <span>{formatSymptomName(symptomKey)}</span>
            <span className="tooltip-symptom-level" style={{ color: color }}>
              {level}
            </span>
          </div>
        )
      })}
    </div>
  )
}

export const MenopauseBarChart = (props) => {
  const menopauseSurveyData = props.menopauseSurveyData || {}
  const fullData = props.fullData || {}

  const chartData = Object.entries(menopauseSurveyData).map(function([
    category,
    percentage
  ]) {
    return {
      category: category,
      percentage: typeof percentage === 'number' ? percentage : 0
    }
  })

  if (chartData.length === 0) return null

  return (
    <ResponsiveContainer
      width={400}
      height={350}
      className="menopause-chart-container"
    >
      <BarChart
        data={chartData}
        layout="vertical"
        margin={{ top: 50, right: 40, left: 60, bottom: 20 }}
        barCategoryGap={30}
      >
        <XAxis
          type="number"
          domain={[0, 100]}
          tickFormatter={(value) => `${value}%`}
        />
        <YAxis type="category" dataKey="category" />
        <Tooltip content={<CustomTooltip fullData={fullData} />} />
        <Bar dataKey="percentage" fill="#2B4B8F" barSize={40}>
          <LabelList
            dataKey="percentage"
            position="right"
            formatter={(val) => `${val}%`}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}
